<template>
    <div class="inside_pages_right">
        <BrightKitchen></BrightKitchen>
       <div class="inside_pages_right_content">
            <div class="inside_pages_content_two" v-show="listBox == true">
                <div class="content_top_three ">
                    <div class="inside_pages_right_content_top_left ">
                        <el-button type="primary" plain size="mini" icon="el-icon-s-operation" @click="$Common.pageJump('/alarm_equipment',0)">
                            报警设备管理
                        </el-button>
                        <el-button type="danger" plain size="mini" icon="el-icon-circle-close">
                            删除
                        </el-button>
                    </div>

                    <div class="inside_pages_right_content_top_right">
                        <el-date-picker
                        v-model="requestData.date1"
                        size="mini"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                        </el-date-picker>&nbsp;
                        <el-select v-model="requestData.type" placeholder="报警类型" size="mini">
                            <el-option label="请选择报警类型" value="">
                            </el-option>
                            <el-option label="警戒区域检查（室外）" value="0">
                            </el-option>
                            <el-option label="出入摘要" value="1">
                            </el-option>
                        </el-select> &nbsp;
                        <el-input v-model.trim="requestData.name"  size="mini" placeholder="请输入设备编号"></el-input> &nbsp;
                        <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                    </div>
                </div>
                <div class="content_center_three">
                    <el-table :data="responseData.list"  height="100%" border style="width: 100%"  @selection-change="selectActionData">
                        <el-table-column type="selection" width="40"> </el-table-column>
                        <el-table-column prop="id" label="设备ID" width="120">
                        </el-table-column>

                        <el-table-column prop="name1" label="报警内容">
                            <template slot-scope="scope">
                                <div v-if="scope.row.name1 == 0">暂无报警内容</div>
                                <div v-if="scope.row.name1 != 0" class="demo-image__preview">
                                    <el-image 
                                        style="width: 100px; height: 100px" :src="$store.state.config.fileUrl+scope.row.name1" 
                                        :preview-src-list="[$store.state.config.fileUrl+scope.row.name1]">
                                    </el-image>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column prop="name2" label="报警类型">
                        </el-table-column>

                        <el-table-column prop="name3" label="设备地点">
                        </el-table-column>

                        <el-table-column prop="name4" label="设备编号">
                        </el-table-column>

                        <el-table-column prop="date1" label="报警时间">
                            <template slot-scope="rowData">
                                {{$Common.dateFormatDate(rowData.row.date1)}}
                            </template>
                        </el-table-column>

                        <el-table-column  label="操作" width="240">
                            <template slot-scope="scope">
                                <el-button  type="primary" plain  size="mini">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="content_bottom_three">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="responseData.pageNum"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="responseData.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrightKitchen from '@/components/BrightKitchen'
export default {
    name:'',
    components: {BrightKitchen},
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            listBox:true,
            editBox:false,
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                type:'',
                name:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:0,
                pages:0,
                list:[
                    {
                        id:99999,
                        name1:'images/20200702/4bfc2300ec804852af8afdd2922d3d76.png',
                        name2:'警戒区检测(室外)',
                        name3:'通道_14_告警	',
                        name4:'7A3378DB29F34622B6CFDB346F562BC9',
                        date1:1593273599,
                     
                    },
                  
                ],
            },
            selectedDataList:[],

        };
    },
    watch: {},
    computed: {},
    methods: {
        selectActionData(selectData){
            this.selectedDataList = []
            selectData.forEach(element => {
                this.selectedDataList.push(element.id)
            });

            // console.log(this.selectedDataList)
        },
        openEditBox(){
            this.listBox = false
            this.editBox = true
        },
        
        closeEditBox(){
            this.listBox = true
            this.editBox = false
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }

      
    },
    created() {},
    mounted() {
    }
};
</script>
<style scoped>
</style>